module.exports = __webpack_public_path__ + "static/media/Investography- Purchase, SIP and Biller Registration Process.9f4a6250.pdf";